import React, { useState, useMemo } from 'react';
import { Badge, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronDown, faTags
} from '@fortawesome/free-solid-svg-icons';
import { formatScope } from '../utils/helpers';



// ── Assigned permissions grouped view ────────────────────────────────────────
const PermissionsTree = ({ assignments, type }) => {
  const [openModules, setOpenModules] = useState({});
  const [openRTs, setOpenRTs] = useState({});

  const grouped = useMemo(() => {
    const groups = {};
    assignments.forEach(a => {
      const cap = a.capability || {};
      const mod = cap.moduleKey || (type === 'role' ? (a.role?.name || 'Role') : 'General');
      const rt = cap.targetResourceType || 'Other';
      if (!groups[mod]) groups[mod] = {};
      if (!groups[mod][rt]) groups[mod][rt] = [];
      groups[mod][rt].push(a);
    });
    return groups;
  }, [assignments]);

  const moduleKeys = Object.keys(grouped).sort();
  const toggleModule = (mod) => setOpenModules(p => ({ ...p, [mod]: !p[mod] }));
  const toggleRT = (key) => setOpenRTs(p => ({ ...p, [key]: !p[key] }));

  if (assignments.length === 0) return null;

  return (
    <div className="module-groups-list">
      {moduleKeys.map(mod => {
        const rts = grouped[mod];
        const modOpen = !!openModules[mod];
        const total = Object.values(rts).flat().length;
        return (
          <div key={mod} className="module-group">
            <div className="module-group-header" onClick={() => toggleModule(mod)}>
              <div className="module-header-left">
                <FontAwesomeIcon icon={faChevronDown} className={`rt-collapse-icon ${modOpen ? '' : 'collapsed'}`} />
                <span className="module-header-name">{mod}</span>
                <Badge className="auth-badge-role module-count-badge">{total}</Badge>
              </div>
            </div>
            {modOpen && (
              <div className="module-group-body">
                {Object.entries(rts).sort(([a],[b]) => a.localeCompare(b)).map(([rt, items]) => {
                  const rtKey = `${mod}__${rt}`;
                  const rtOpen = !!openRTs[rtKey];
                  return (
                    <div key={rt} className="role-modal-rt-group">
                      <div className="role-modal-rt-header" onClick={() => toggleRT(rtKey)}>
                        <div className="rt-header-left">
                          <FontAwesomeIcon icon={faChevronDown} className={`rt-collapse-icon ${rtOpen ? '' : 'collapsed'}`} />
                          <span className="rt-header-name">{rt}</span>
                          <Badge className="rt-count-badge">{items.length}</Badge>
                        </div>
                      </div>
                      {rtOpen && (
                        <div className="caps-assign-list">
                          {items.map(a => (
                            <div key={a.id} className="perm-assigned-row">
                              <div className="perm-assigned-info">
                                <strong>{type === 'role' ? (a.role?.name || `Role #${a.roleId}`) : (a.capability?.name || `Cap #${a.capabilityId}`)}</strong>
                                <div className="perm-scope-row mt-1">
                                  <FontAwesomeIcon icon={faTags} className="me-1 text-muted" style={{fontSize:'0.75rem'}} />
                                  <span className="perm-scope-text">{formatScope(a.scope)}</span>
                                </div>
                              </div>
                              <Badge className={`hierarchy-badge ${a.allowHierarchy ? 'active' : ''}`}>
                                {a.allowHierarchy ? 'Hierarchy ON' : 'Strict'}
                              </Badge>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default PermissionsTree;